import { render } from "./CertificationCourses.vue?vue&type=template&id=b69ff144&scoped=true"
import script from "./CertificationCourses.vue?vue&type=script&lang=js"
export * from "./CertificationCourses.vue?vue&type=script&lang=js"

import "./CertificationCourses.vue?vue&type=style&index=0&id=b69ff144&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b69ff144"]])

export default __exports__